import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { t } from '../i18n';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    if (!token) setError(t('resetInvalidToken'));
  }, [token]);

  const handle = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) {
      setError(t('profilePasswordTooShort'));
      return;
    }
    if (password !== confirm) {
      setError(t('profilePasswordMismatch'));
      return;
    }
    setLoading(true);
    try {
      const res = await fetch('/api/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      setSuccess(data.message);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #f0fdf4 0%, #fafdf5 60%, #dcfce7 100%)',
      padding: 24
    }}>
      <div className="card" style={{ width: '100%', maxWidth: 400, padding: 40 }}>
        <Link to="/" style={{ fontSize: 40, textAlign: 'center', marginBottom: 8, display: 'block', textDecoration: 'none' }}>🍵</Link>
        <h2 style={{ fontSize: 24, textAlign: 'center', marginBottom: 8 }}>{t('resetPasswordTitle')}</h2>
        <p style={{ color: 'var(--text-muted)', textAlign: 'center', fontSize: 15, marginBottom: 28 }}>
          {t('resetPasswordSubtitle')}
        </p>

        {error && (
          <div style={{
            background: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca',
            borderRadius: 8, padding: '10px 14px', fontSize: 14, marginBottom: 20
          }}>{error}</div>
        )}

        {success && (
          <div style={{
            background: '#f0fdf4', color: '#166534', border: '1px solid #bbf7d0',
            borderRadius: 8, padding: '10px 14px', fontSize: 14, marginBottom: 20
          }}>
            {success}
            <div style={{ marginTop: 8, fontSize: 13 }}>{t('resetRedirectingLogin')}</div>
          </div>
        )}

        {!success && token && (
          <form onSubmit={handle} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div>
              <label style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-muted)', display: 'block', marginBottom: 6 }}>
                {t('profileNewPassword')}
              </label>
              <input
                className="input"
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                minLength={8}
              />
            </div>
            <div>
              <label style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-muted)', display: 'block', marginBottom: 6 }}>
                {t('profileConfirmPassword')}
              </label>
              <input
                className="input"
                type="password"
                placeholder="••••••••"
                value={confirm}
                onChange={e => setConfirm(e.target.value)}
                required
                minLength={8}
              />
            </div>
            <button
              type="submit"
              className="btn btn-primary"
              style={{ marginTop: 8, justifyContent: 'center', padding: '12px' }}
              disabled={loading}
            >
              {loading ? '...' : t('resetPasswordBtn')}
            </button>
          </form>
        )}

        <p style={{ marginTop: 24, textAlign: 'center', fontSize: 14, color: 'var(--text-muted)' }}>
          <Link to="/login" style={{ color: 'var(--match-a)', fontWeight: 600 }}>{t('goToLogin')}</Link>
        </p>
      </div>
    </div>
  );
}
